export const agnieszkaGorna = {
    'firstName': 'Agnieszka',
    'lastName': 'Górna',
    'profession': 'Psychoterapeutka psychodynamiczna w trakcie szkolenia, dyplomowany coach, mediator sądowy',
    'avatar': 'agnieszka-gorna.webp',
    'slug': 'psychoterapeuta-agnieszka-gorna',
    'locations': ['torun'],
    'services': [
        ['psychoterapy', 'adult'],
    ]
}